var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{staticClass:"text-subtitle-1 font-weight-bold"},[_vm._v(_vm._s(_vm.metric))]),_c('MetricChart',{attrs:{"loading":_vm.loading,"resolved":_vm.resolved,"timeseries":_vm.timeseries,"time":_vm.time,"event-bus":_vm.eventBus,"group":_vm.chartGroup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }